import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { resetReducers } from "../model/system/systemActionCreators";

export const useResetStore = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  React.useEffect(() => {
    const segments = pathname.split("/").filter((item) => item);

    let firstSegment = segments[0];

    if (firstSegment === "archive" && segments[1]) {
      firstSegment = segments[1];
    }

    dispatch(resetReducers(firstSegment));
  }, [pathname, dispatch]);

  return null;
};
